<div class="hero-skew d-none d-lg-block">
  <div class="container">
    <div class="hero-right-panel hero-right-panel-ext">
      <div class="row no-gutters hero-menu-group justify-content-end">
        @if (pageType === 'skiHire') {
          @for (slide of heroSliderService.slides; track slide; let i = $index) {
            <div
              class="hero-menu-item js-hero-menu-item"
              [class.is-active]="i === heroSliderService.activeSlide"
              (click)="updateActiveSlide(i)">
              <div data-test="heroSliderElement" class="hero-menu-content">
                <app-icon [name]="slide.tabIconClass" class="hero-icon" />
                <div>{{ slide.tabName | alpitranslate }}</div>
              </div>
            </div>
          }
        }
        @if (pageType === 'skiSchool') {
          <div class="hero-menu-item js-hero-menu-item is-active">
            <div class="hero-menu-content">
              <app-icon [name]="heroSliderService.slides[0].tabIconClass" class="hero-icon" />
              <div>{{ heroSliderService.slides[0].tabName | alpitranslate }}</div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
